import type { User } from "../../user";

export enum FavoriteVehicleTypeDTO {
  CAR = 1,
  BIKE = 2,
}

export type FavoriteItemDTO = {
  guid: string;
  advertiseId: number;
  site: boolean;
  vehicleType: FavoriteVehicleTypeDTO;
  brand?: string;
  brandId?: number;
  model?: string;
  modelId?: number;
  version?: string;
  versionId?: number;
  price?: number;
  odometer?: number;
  yearFabrication?: number;
  yearModel?: number;
  primaryColor?: string;
  city?: string;
  state?: string;
  sellerType?: string;
  advertiser?: string;
  advertiserId?: number;
  active?: boolean;
  createDate?: string;
  numberPorts?: number;
  listingType?: string;
  photos?: string[];
  cubicCentimeter?: number;
};

export type FavoritesDTO = {
  favorites: FavoriteItemDTO[];
  count: number;
};

/**
 * A single page of favorites for one vehicle type, including the pagination
 * metadata needed to drive infinite scroll on the favorites screen.
 */
export type FavoritesPageDTO = {
  favorites: FavoriteItemDTO[];
  /** Total number of favorites of this vehicle type. */
  count: number;
  /** Page that was fetched (1-based). */
  page: number;
  /** Total number of pages available for this vehicle type. */
  totalPages: number;
};

export type FavoriteApiResultDTO = {
  advertise_id: number;
  guid: string;
  price?: number;
  brand?: string;
  brandId?: number;
  model?: string;
  modelId?: number;
  version?: string;
  versionId?: number;
  odometer?: number;
  year_fabrication?: number;
  year_model?: number;
  primary_color?: string;
  city?: string;
  state?: string;
  seller_type?: string;
  advertiser?: string;
  advertiserId?: number;
  active?: boolean;
  create_date?: string;
  number_ports?: number;
  listing_type?: string;
  photos?: string[];
  image_path?: string;
  cubic_centimeter?: number;
};

export type FavoriteApiResponseDTO = {
  count: number;
  results: FavoriteApiResultDTO[];
  /** Total number of pages, as reported by the API. */
  pages?: number;
  /** Page returned by the API (1-based). */
  actual_page?: number;
};

export type AddFavoriteDTO = {
  user: User | null;
  id: number;
  vehicleType: string;
};

export type AddFavoriteApiResultDTO = {
  excludeFavoriteKey: string;
  id: number;
};

export type RemoveFavoriteDTO = {
  guid: string;
  user: User | null;
};
